import { lloFetch } from '../../helpers/lloFetch';
import trans from '../../helpers/trans';
import { FetchResult, FetchResultType } from '../FetchResult';
import { InternalOccupationFilterValues, InternalOccupationOverview, InternalOccupationOverviewResource } from './InternalOccupationOverview';
import { transformToInternalOccupationOverview } from './InternalOccupationOverviewTransformers';

export const getInternalOccupationOverviewApiCall = async (
    candidateUuid: string,
    activeFilterValues: InternalOccupationFilterValues,
): Promise<FetchResult<InternalOccupationOverview, string>> => {
    try {
        const searchQuery = activeFilterValues.searchQuery || '';

        const response = await lloFetch(`/api/internalOccupations/matching?search=${searchQuery}`, { candidateUuid });

        if (!response.ok) {
            return {
                status: response.status,
                type: FetchResultType.Error,
                error: trans('errors.unknownError'),
            };
        }

        const occupationOverviewResponse: InternalOccupationOverviewResource = await response.json();

        const occupationOverview = transformToInternalOccupationOverview(occupationOverviewResponse);

        return {
            status: response.status,
            type: FetchResultType.Success,
            data: occupationOverview,
        };
    } catch (error) {
        console.error('[getInternalOccupationOverviewApiCall]', error);

        return {
            status: 500,
            type: FetchResultType.Error,
            error: trans('errors.unknownError'),
        };
    }
};
